import React from "react";
import styled from "styled-components";
import { Text } from "@mantine/core";

import azizilogo from "../assets/images/azizi-logo.png";
import nshamalogo from "../assets/images/nshama-logo.png";
import meraaslogo from "../assets/images/meraas-logo.png";
import danubelogo from "../assets/images/danube-logo.png";
import damaclogo from "../assets/images/damac-logo.png";

// Container for the entire section
const PartnerSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  padding-top: 6rem;
  width: 80%;
  margin: 0 auto;
`;

// Title styles
const Title = styled(Text)`
  font-size: 2.5rem;
  font-weight: bold;
  font-family: "Paris Avenue";
`;

// Subtitle styles
const Subtitle = styled(Text)`
  font-size: 1.2rem;
  color: #666;
  margin: 0;
  text-align: center;
  @media (max-width: 768px) {
    margin-bottom: 1rem;
  }
  @media (max-width: 480px) {
    margin-bottom: 1rem;
  }
`;

// Marquee container
const MarqueeContainer = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;
  position: relative;
`;

// Inner container for scrolling content
const MarqueeInner = styled.div`
  position: relative;
  top: -2rem;
  display: flex;
  width: max-content;
  animation: marquee 20s linear infinite;

  @keyframes marquee {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }

  /* Duplicate content to create a seamless loop */
  &:after {
    content: "";
    display: flex;
    width: max-content;
    animation: marquee 20s linear infinite;
  }

  @media (max-width: 768px) {
    animation: marquee 30s linear infinite; /* Slower on smaller screens */
    &:after {
      animation: marquee 30s linear infinite;
    }
  }
`;

// Logo styles
const Logo = styled.img`
  height: 300px;
  width: auto;
  margin: 0;
  object-fit: cover;
  clip-path: inset(40% 0);
  object-position: center;
  ${"" /* transform: scale(1.8); */}

  @media (max-width: 768px) {
    height: 180px;
    ${"" /* transform: scale(1.5); */}
  }

  @media (max-width: 480px) {
    height: 150px;
    ${"" /* transform: scale(1.3); */}
  }
`;

const Brands = () => {
  const logos = [damaclogo, danubelogo, meraaslogo, nshamalogo, azizilogo];

  return (
    <PartnerSection id="brands">
      <Title> Our Partners </Title>
      <Subtitle> We are honored to have these amazing partners. </Subtitle>
      <MarqueeContainer>
        <MarqueeInner>
          
          {logos.map((logo, index) => (
            <Logo key={index} src={logo} alt={`Partner ${index}`} />
          ))}
          {/* Repeat logos to ensure seamless looping */}
          {logos.map((logo, index) => (
            <Logo
              key={`duplicate-${index}`}
              src={logo}
              alt={`Partner ${index}`}
            />
          ))}
        </MarqueeInner>
      </MarqueeContainer>
    </PartnerSection>
  );
};

export default Brands;
